import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import LoginView from '../views/auth/LoginView.vue'
import SellView from '../views/sell/SellView.vue'
import TablesView from '../views/table/TablesView.vue'
import MainLayout from '../layouts/MainLayout.vue'
import PosView from '../views/pos/PosView.vue'
import OrdersView from '../views/order/OrdersView.vue'
import ListOrganizationsView from '../views/organizations/ListOrganizationsView.vue'
import { getOrganization, getToken } from '@/utils/auth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/organizations',
    name: 'organizations',
    component: ListOrganizationsView,
  },
  {
    path: '/',
    component: MainLayout,
    children: [
      // {
      //   path: '/',
      //   name: 'home',
      //   component: HomeView
      // },
      {
        path: '/',
        name: 'sell',
        component: SellView
      },
      {
        path: '/tables',
        name: 'tables',
        component: TablesView
      },
      {
        path: '/pos/:tab_id?',
        name: 'pos',
        props: true,
        component: PosView
      },
      { path: '/orders/:id?', name: 'orders', component: OrdersView, props: true },

    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const authRoutes = ['login']
  const token = getToken()
  const organization = getOrganization()

  // Verificação de autenticação e organização
  if (!authRoutes.includes(to.name as string) && !token) {
    return next({ name: 'login' })
  } else if (
    to.name !== 'organizations' &&
    token &&
    !organization
  ) {
    return next({ name: 'organizations' })
  }

  if (authRoutes.includes(to.name as string) && !!token) {
    if (organization) {
      return next({ name: 'sell' })
    } else {
      return next({ name: 'organizations' })
    }
  }

  next()
})

export default router
